import { referrerQueries } from '../queries/queries'

const queryReferrer = (referral_code, success, error) => ({
  type: 'API:REFERRER',
  API: true,
  method: 'POST',
  url: '/api/query',
  success,
  error,
  data: {
    query: referrerQueries.QUERY_REFERRER,
    variables: { referral_code }
  }
})

const receiveReferral = (referral_code, success, error) => ({
  type: 'API:RECEIVE_REFERRAL',
  API: true,
  method: 'POST',
  url: '/api/query',
  success,
  error,
  data: {
    query: referrerQueries.MUTATION_RECEIVE_REFERRAL,
    variables: { input: { referral_code } }
  }
})

export default { queryReferrer, receiveReferral }
